import React, { Component } from 'react';
import { gql } from '@apollo/client';
import { apolloClient } from '../Root';

const SEARCH_SF_TAGS = gql`
  query SearchSfTags($search: String, $locationId: Int!) {
    searchStorefrontTags(search: $search, locationId: $locationId) {
      id
      name
      __typename
    }
  }
`;

const withTags = (WrappedComponent) => {
  return class WithTagsHOC extends Component {
    constructor(props) {
      super(props);
      this.searchTags = this.searchTags.bind(this);
    }

    searchTags = async (search, locationId) => {
      try {
        const { data } = await apolloClient.query({
          query: SEARCH_SF_TAGS,
          variables: { search, locationId },
          fetchPolicy: 'network-only',
        });
        return data.searchStorefrontTags;
      } catch (error) {
        console.error('Error searching tags:', error);
        return [];
      }
    };

    render() {
      return <WrappedComponent {...this.props} searchTags={this.searchTags} />;
    }
  };
};

export default withTags;
